import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { IShippingData } from 'interfaces/IProductData';
import { paymentService } from './PaymentService';
import { cartService } from 'services/CartService';
import { IS_ECOMMERCE, IS_SHOPIFY } from 'settings';

export class ShippingService {
  private shipping$ = new ReplaySubject<IShippingData>(1);
  private loaded = false;

  constructor() {
    cartService
      .getCart()
      .combineLatest(paymentService.getCart())
      .filter(([cart]) => {
        if (IS_ECOMMERCE || cart.isCached) {
          return false;
        }

        return true;
      })
      .map(([cart, payment]) => {
        const data = {
          postalCode: (payment.address && payment.address.postalCode) || '',
          province: (payment.address && payment.address.province) || '',
          quantity: Number(payment.quantity || 0),
          price: payment.fullPrice,
          coupon: cart.coupon,
          products: payment.products,
          currency: cart.config.currency,
          mustEstimate: cart.config.mustEstimate
        };

        return data;
      })
      .filter(data => (IS_SHOPIFY && !!data.province) || !IS_SHOPIFY)
      .distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
      .debounceTime(500)
      .switchMap(data => {
        const shipping$ = cartService.setShippingData(data.products, data.postalCode);

        if (this.loaded === false) {
          return shipping$;
        }

        return shipping$.loader();
      })
      .subscribe(shippings => {
        this.loaded = true;
        this.shipping$.next(shippings);

        if (shippings.shippingItems.length > 0) {
          cartService.setShipping(shippings.hash, shippings.shippingItems[0]);
        }
      });
  }

  public getShipping(): Observable<IShippingData> {
    return this.shipping$.asObservable().distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b));
  }
}

// tslint:disable-next-line:variable-name
export const ShippingServiceFactory = () => new ShippingService();

export const shippingService = ShippingServiceFactory();
